(ns minorodata.components.monaco.completions
  (:require [applied-science.js-interop :as js-interop]
            [minorodata.components.monaco.editor :as monaco.editor]
            [minorodata.sql-console.events :refer [worker]]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]))


(defn completions-fn [model position _]
  (js/Promise.
    (fn [resolve]
      (let [word-obj             (js-interop/call model :getWordUntilPosition position)
            word                 (js-interop/get word-obj :word)
            text-before-cursor   (js-interop/call model :getValueInRange
                                   #js {:startLineNumber (js-interop/get position :lineNumber)
                                        :endLineNumber   (js-interop/get position :lineNumber)
                                        :startColumn     1
                                        :endColumn       (js-interop/get position :column)})
            completion-candidate (first (re-find #"([\w\.]+)$" text-before-cursor))]


        (.. worker (addEventListener
                    "message"
                    (fn [e]
                      (let [type (js-interop/get-in e [:data :type])
                            data (js-interop/get-in e [:data :data])]
                        (when (= type "match-completions")
                          (resolve #js {:suggestions data}))))
                    #js {:once true}))

        (.. worker (postMessage #js {:type "match-completions"
                                     :data #js {:word        word
                                                :candidate   completion-candidate}}))))))


(defn add-completions-provider [language f monaco]
  (let [monaco-languages (js-interop/get monaco :languages)]
    (js-interop/apply monaco-languages
                      :registerCompletionItemProvider
                      #js [language #js {:provideCompletionItems f}])))

(defonce completions-provider
  (reagent/atom nil))


(defn init-completions-provider [monaco]
  (when-some [provider @completions-provider]
    (js-interop/call provider :dispose))

  (reset! completions-provider (add-completions-provider "sql" completions-fn monaco)))
